import { NavLink as Link, Outlet, useLocation } from "react-router-dom";
import { Fragment, useContext, useEffect } from "react";
import { MenuContext } from "../Context/Menucontext";
import { AuthContext } from "../Context/AuthContext";
import { ReactComponent as MenuIcon } from "../Asset/menu-alt-2-svgrepo-com 1.svg";
import { ReactComponent as VatugIcon } from "../Asset/Layer_1.svg";
import { ReactComponent as BlackVatugIcon } from "../Asset/black.svg";
import { LiaTimesSolid } from "react-icons/lia";
import AuthDrop from "../Pages/IsauthDrop/Isauth";
import { useNavigate } from "react-router-dom";
import { VscBell } from "react-icons/vsc";
import { GiHamburgerMenu } from "react-icons/gi";
import "./Navbar.css";

const Navbar = () => {
  const {
    isMobile,
    setIsMobile,
    scrollPosition,
    setScrollPosition,
    isauthDrop,
    setIssAuthDrop,
  } = useContext(MenuContext);
  const { isAuthenticated, user, logout, token, role } =
    useContext(AuthContext);
  const userEmailInitial = user?.email.charAt(0).toUpperCase();
  const navigate = useNavigate();
  const userType = localStorage.getItem("userType");
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [setScrollPosition]);

  const isHomePage = location.pathname === "/";

  const handleMobileMenuClick = () => {
    setIsMobile(!isMobile);
    setScrollPosition(24);
  };

  const isScrolled = scrollPosition > 23;

  const handleProfileClick = () => {
    setIsMobile(false);
    if (userType === "Charterer") {
      navigate("/mobileprofile");
    } else if (userType === "Vessel Owner") {
      navigate("/mobile_v");
    } else {
      alert("User type is missing. Please select your user type.");
    }
  };



  const handleLoginClick = () => {
    navigate("/choose_login"); 
    setIsMobile(false);
  };

  const linkStyle = (isActive) => ({
    color: isActive ? "#ff451f" : isHomePage && !isScrolled ? "white" : "black",
  });

  return (
    <Fragment>
      {isauthDrop && <AuthDrop />}
      <div className={isScrolled ? "navbar scrolled" : "navbar"}>
        <div className="wrapper">
          <Link to="/">
            {isHomePage && !isScrolled ? (
              <VatugIcon onClick={() => setIsMobile(false)} />
            ) : (
              <BlackVatugIcon onClick={() => setIsMobile(false)} />
            )}
          </Link>

          <div
            className={`navbar-links ${isMobile ? "mobile-link active" : ""}`}
          >
            <div className="main">
              <Link
                to="/about_us"
                style={({ isActive }) => linkStyle(isActive)}
                onClick={() => setIsMobile(false)}
              >
                About Us
              </Link>
              <Link
                to="/edge"
                style={({ isActive }) => linkStyle(isActive)}
                onClick={() => setIsMobile(false)}
              >
                Our Edge
              </Link>
              <Link
                to="/explore"
                style={({ isActive }) => linkStyle(isActive)}
                onClick={() => setIsMobile(false)}
              >
               Features
              </Link>
              <Link
                to="/vessel_financing"
                style={({ isActive }) => linkStyle(isActive)}
                onClick={() => setIsMobile(false)}
              >
              Financing
              </Link>
              <Link
                to="/news"
                style={({ isActive }) => linkStyle(isActive)}
                onClick={() => setIsMobile(false)}
              >
                News
              </Link>
              <Link
                to="/contact_us"
                style={({ isActive }) => linkStyle(isActive)}
                onClick={() => setIsMobile(false)}
              >
                Contact
              </Link>

              {isAuthenticated && token && role === "vesselOwner" && (
                <>
                  <Link
                    to="/create_vessel"
                    className="nav-nots"
                    style={({ isActive }) => linkStyle(isActive)}
                    onClick={() => setIsMobile(false)}
                  >
                    Upload Vessel
                  </Link>
                  <Link
                    to="/myvessels"
                    className="nav-nots"
                    style={({ isActive }) => linkStyle(isActive)}
                    onClick={() => setIsMobile(false)}
                  >
                    My Vessels
                  </Link>
                </>
              )}

              {isAuthenticated && token && (
                <Link
                  to="/notifications"
                  className="nav-nots"
                  style={({ isActive }) => linkStyle(isActive)}
                  onClick={() => setIsMobile(false)}
                >
                  Notifications
                </Link>
              )}

              {!isAuthenticated && (
                <div className="auth-main">
                  <div
                   
                    onClick={handleLoginClick}
                  >
                    Log in
                  </div>
                  <Link
                    to="/ChooseAccount"
                    onClick={() => setIsMobile(false)}
                  >
                    Signup
                  </Link>
                </div>
              )}
              {isAuthenticated && token && (
                <button className="profile-per" onClick={handleProfileClick}>
                  Profile
                </button>
              )}

              {isAuthenticated && token && (
                <button
                  className="logout-nav"
                  onClick={() => {
                    logout();
                    setIsMobile(false);
                  }}
                >
                  Sign out
                </button>
              )}
            </div>
          </div>

          <div className="public">
            {isAuthenticated && token ? (
              <div className="bell">
                <button className="profile-per" onClick={handleProfileClick}>
                  Personal Info
                </button>
                <VscBell
                  onClick={() => navigate("/notifications")}
                  className="ring"
                  style={{
                    color: isHomePage && !isScrolled ? "white" : "black",
                  }}
                />
                <div
                  className="islogin"
                  onClick={() => setIssAuthDrop(!isauthDrop)}
                >
                  <p>{userEmailInitial}</p>
                  <MenuIcon />
                </div>
              </div>
            ) : (
              <div className="auth">
                <div
                  style={{ color: isHomePage && !isScrolled ? "white" : "" }}
                  onClick={handleLoginClick}
                >
                  Log in
                </div>
                <Link
                  to="/ChooseAccount"
                  style={{ color: isHomePage && !isScrolled ? "white" : "" }}
                  onClick={() => setIsMobile(false)}
                >
                  Signup
                </Link>
              </div>
            )}
          </div>
          <div className="mobile-menu" onClick={handleMobileMenuClick}>
            {isMobile ? (
              <LiaTimesSolid
                style={{ color: isHomePage && !isScrolled ? "white" : "black" }}
              />
            ) : (
              <GiHamburgerMenu
                style={{ color: isHomePage && !isScrolled ? "white" : "black" }}
                className="fa-bars"
              />
            )}
          </div>
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default Navbar;
